import React from 'react';
import { useLocation } from 'react-router-dom';

const PlatformMaintenanceBanner = () => {
  const { pathname } = useLocation();

  const now = new Date();
  // const startTime = new Date('2026-04-10T00:00:00+08:00');
  // const endTime = new Date('2026-04-12T23:59:59+08:00');

  const startTime = new Date('2026-04-01T16:00:00+08:00');
  const endTime = new Date('2026-04-01T17:59:59+08:00');

  if (now < startTime || now > endTime) {
    return null;
  }

  return (
    <div className="w-full text-center px-4 py-3 z-50 text-sm md:text-base text-black" style={{ backgroundColor: 'rgb(245 164 164)' }}>
      <p>
        <span className="mr-2">⚠️</span>
        <span className="font-bold">Platform Maintenance Notice:</span> We're launching a simplified membership (Free & All Access). All sign-ups will be paused <span className="font-bold">Apr 10–12, 2026.</span> The platform will be offline on <span className="font-bold">Apr 13 2026,</span> 10am–12pm SGT (~2 hours) during which logins and all actions will be temporarily unavailable. Thank you for your patience!
      </p>
    </div>
  );
};

export default PlatformMaintenanceBanner;
